import { render, staticRenderFns } from "./site-text-block.vue?vue&type=template&id=9efd6688"
import script from "./site-text-block.vue?vue&type=script&lang=js"
export * from "./site-text-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports